import { Controller } from 'react-hook-form';
import { FormProps } from '../types';
import { Input } from 'antd';

export function FormEmail({
  t,
  control,
  name,
  label,
  placeholder,
  disabled,
  error,
}: FormProps) {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const getError = () => {
    if (error?.type === 'pattern') {
      return t('errors.formErrors.isNotValid', {
        name: t(`forms.${name}`),
      });
    }
    return t(error?.message?.toString()!);
  };
  return (
    <>
      {label && (
        <label>
          {typeof label === 'string' ? t(label) : (label as React.ReactNode)}
        </label>
      )}
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Input
            size='large'
            {...field}
            placeholder={t(placeholder ?? '')}
            required
            disabled={disabled}
            className='border-none h-14 rounded-2xl'
          />
        )}
        rules={{
          required: true,
          pattern: {
            value: emailRegex,
            message: t('errors.invalidEmail'),
          },
        }}
      />
      {error && <span className='text-red-500'>{getError()}</span>}
    </>
  );
}
